import type { Routes } from '@angular/router';

import { CREDENTIALS_ROUTES } from '#core/credentials/credentials.routing';
import { selectOrganizationGuard } from '#core/guards/select-organization.guard';
import { GroupsResolver } from '#core/resolvers/groups.resolver';
import { RestaurantResolver } from '#core/resolvers/restaurant.resolver';
import { restaurantAwaitingSubscriptionGuard } from '#modules/restaurants/guards/restaurant-awaiting-subscription.guard';
import { RESTAURANTS_LIST_ROUTES } from '#modules/restaurants/routes/restaurant-list.routing';
import { RestaurantStore } from '#modules/restaurants/stores/restaurant.store';
import { GROUPS_ROUTES } from '#shell/routing/logged-in/groups/groups.routing';
import { RESTAURANTS_ROUTES } from '#shell/routing/logged-in/restaurants/restaurants.routing';
import { provideSidenavScope } from '#shell/routing/logged-in/sidenav/sidenav.providers';

export const SIDENAV_ROUTER_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/sidenav-layout/sidenav-layout.component').then((m) => m.SidenavLayoutComponent),
        providers: [provideSidenavScope()],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'restaurants',
            },
            {
                path: 'restaurants',
                loadChildren: () => RESTAURANTS_LIST_ROUTES,
            },
            {
                path: 'credentials',
                loadChildren: () => CREDENTIALS_ROUTES,
            },
            {
                path: 'restaurants/:restaurant_id',
                providers: [RestaurantResolver, RestaurantStore],
                resolve: { restaurant: RestaurantResolver },
                canActivateChild: [restaurantAwaitingSubscriptionGuard],
                loadChildren: () => RESTAURANTS_ROUTES,
            },
            {
                path: 'groups',
                providers: [GroupsResolver],
                resolve: { groups: GroupsResolver },
                canActivate: [selectOrganizationGuard],
                loadChildren: () => GROUPS_ROUTES,
            },
        ],
    },
];
